import {
  MappedGuest,
  OvernightPackageRoomExtras,
} from '@features/DynamicPackagesConfigurationWizardNew/types';
import { Rate } from '@features/rates/types';
import { parseDateToString } from '@utils/helpers';

import { mapExtrasToBasket } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/utils';
import { RoomExtra } from '@features/rooms';

export function parseRoomDetailsForBasket({
  roomRateEntity,
  guests,
  roomId,
  adults,
  children,
  childAges,
  fromDate,
  toDate,
  note,
  formExtras,
  availableExtras,
  promoRateCode,
}: {
  roomRateEntity: Rate;
  guests: MappedGuest[];
  roomId: string;
  adults: number;
  children: number;
  childAges?: { [child: string]: number };
  fromDate: string;
  toDate: string;
  note?: string;
  formExtras?: OvernightPackageRoomExtras;
  availableExtras: RoomExtra[];
  promoRateCode?: string;
}) {
  const extrasMapped = mapExtrasToBasket(availableExtras, formExtras);
  return [
    {
      quantity: 1,
      type: 'rooms',
      check_in: parseDateToString(fromDate),
      check_out: parseDateToString(toDate),
      adults,
      children,
      guest_details: guests,
      bookable: {
        ids: {
          rate_id: roomRateEntity.id,
          room_id: roomId,
          promo_rate_code: promoRateCode ?? null,
        },
        room_extras: extrasMapped,
        ...(childAges && Object.values(childAges).length
          ? { rooms_child_ages: Object.values(childAges) }
          : {}),
      },
      dynamic_package: 'parent',
      ...(note ? { note } : {}),
    },
  ];
}
